export type CareGap = {
  id: string;
  resourceType: "CareGap";
  name: string;
  description: string;
  code: string;
  system: string;
};

export const exampleCareGaps: CareGap[] = [
  {
    id: "a207be85-02d9-761a-9c8b-6224a053ca31",
    resourceType: "CareGap",
    name: "Eye Exam With Evidence of Retinopathy",
    code: "2022F",
    description:
      "Dilated retinal eye exam with interpretation by an ophthalmologist or optometrist documented and reviewed; with evidence of retinopathy (DM)",
    system: "CPT-CAT-II",
  },
];

/**
 * Mapping of population codes to their plain English tooltip descriptions.
 * Used to provide helpful explanations when hovering over population names in care gaps.
 */
export const populationCodeTooltips: Record<string, string> = {
  "initial-population":
    "Patient meets the basic eligibility criteria for this measure (age, enrollment, or condition).",
  "denominator-exclusion":
    "Patient is excluded from this measure due to a valid medical reason (e.g., conflicting condition, hospice care, or the measure doesn't apply).",
  denominator: "Patient is eligible and should receive this care.",
  numerator: "Patient completed the recommended care for this measure.",
};
